import React from 'react'; 
import { FormCheckboxSquare } from '../validation/Form-Components';
import { Field } from '@progress/kendo-react-form';
import tooltipdata from "../data/tooltipdata.json";
import ReactTooltip from 'react-tooltip';
import { islamicFTypeValidator } from '../validation/Validators';
 
const ChkIslamicFType = (props) => {

    const {disabled} = props;
    
    return(
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <Field id={'chkIsamicFtypeDeclare'} 
                    name={'chkIsamicFtypeDeclare'} 
                    component={FormCheckboxSquare}
                    disabled={disabled}
                    validator={islamicFTypeValidator}
                    label={<>
                          <a>{"I/We hereby declare that my/our business is "}</a>
                          <span data-tip={tooltipdata.authPerson.halalCretified} data-place={'bottom'} data-for='Halaltooltip' data-effect='float'>
                            <u className="txtBlue">{"Halal Certified "}</u></span>
                          <ReactTooltip id='Halaltooltip' html={true} className={"mytooltip"} />
                          <a>{"OR income (Profit Before Tax/Revenue) generated from "}</a>
                          <span data-tip={tooltipdata.authPerson.ShariahNonComp} data-place={'bottom'} data-for='Halaltooltip' data-effect='float'>
                            <u className="txtBlue">{"Shariah Non-Compliant Businesses/Activities"}</u></span>
                          <ReactTooltip id='ShariahNonComp' html={true} className={"mytooltip"} />
                          <a>{" is not more than 33%."}</a>{ }</>}
                    />
            </div>
        </div>
   
    )
}

export default ChkIslamicFType